import { useRetailer } from "@faire/retailer-visitor-shared/hooks/retailer/useRetailer";
import { useIsBrandPreview } from "@faire/retailer-visitor-shared/lib/getIsBrandPreview";
import { useQuery as useGetNotificationQuery } from "@faire/web-api--source/endpoints/www/api/retailer/notifications/get-hooks";

// Refetch notifications every 5 minutes as average session length is 15 minutes
const REFETCH_INTERVAL_MS = 1000 * 60 * 5;

export const useNotificationQuery = () => {
  const { retailerToken } = useRetailer();
  const isBrandPreview = useIsBrandPreview();

  return useGetNotificationQuery({
    enabled: !!retailerToken && !isBrandPreview,
    refetchInterval: REFETCH_INTERVAL_MS,
    // Forced refetches are handled by refetchInterval & specific high priority route navigations
    staleTime: Infinity,
  });
};
